export default __webpack_public_path__ + "static/media/muzikawy.6167cb0e.jpg";